import { useMemo } from 'react';
import { SportEvent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useLoginUrl } from '@/shared/hooks/useLoginUrl';

export const DEFAULT_SPORT_EVENT_ID_PARAM = 'defaultSportEventId';

export const useSportPromoLoginUrl = (currentItem?: SportEvent) => {
    const retpath = useMemo(() => {
        const url = new URL(window.location.href);
        if (currentItem) {
            url.searchParams.set(DEFAULT_SPORT_EVENT_ID_PARAM, currentItem.id);
        }
        return url;
    }, [currentItem]);

    return useLoginUrl(retpath);
};
